import {
  AdminBundleAcquisitionPrice,
  BundlePrice,
  Country,
  PagedBundlesOverviewEnvelope,
  SalesChannel,
  VariantOverview,
} from '@cdaas/api-clients/dist/product-service-openapi';
import { AsyncThunkAction } from '@reduxjs/toolkit';

import { AsyncThunkConfig } from '../../../store';
import { FetchAdminBundleProductsParams } from '../../../store/adminBundles';

export interface SalesChannelDrawerBundleInfo {
  name: string;
  brand: string;
  id: number;
}

export interface SalesChannelDrawerProps {
  selectedItems: SalesChannelDrawerBundleInfo[];
  onCloseClick: () => void;
  defaultSalesChannelUuid?: string;
  refreshList?: () => AsyncThunkAction<PagedBundlesOverviewEnvelope | undefined, FetchAdminBundleProductsParams, AsyncThunkConfig>;
}

export interface EditBundleSalesChannelProps {
  bundleId: number;
  salesChannel: SalesChannel;
  bundlePrice?: BundleSalesChannelListItem;
  bundleVariants: VariantsWithMainInfo[];
  country: Country;
  onCancelClick: (salesChannelId: number) => void;
  onSaveClick: (
    bundlePrice: BundlePrice,
    acquisitionPrices: AdminBundleAcquisitionPrice[],
    mode: EditBundleSalesChannelMode,
    salesChannelId: number,
  ) => Promise<SaveStatusOptions>;
  mode: EditBundleSalesChannelMode;
}
export interface BundleVariantProps {
  acquisitionPrices: AdminBundleAcquisitionPrice[];
  errors: BundleErrors;
  variant: VariantsWithMainInfo;
  onTfapPriceOverridenAmountChange: (variant: VariantsWithMainInfo, value: string) => void;
  country: Country;
}

export interface BundleSalesChannelListItem extends BundlePrice {
  name: string;
  currency: string;
}

export interface VariantsWithMainInfo extends VariantOverview {
  isMain: boolean;
}

export enum SaveStatusOptions {
  Success = 'success',
  Error = 'error',
  Disabled = 'disabled',
}

export enum EditBundleSalesChannelMode {
  Add = 'add',
  Edit = 'edit',
}
export enum EditBundleSalesChannelErrorType {
  MissingMaterial = 'missing_material',
  FinanceId = 'finance_id',
  FinanceName = 'finance_name',
  TfapDefault = 'tfap_default',
}

export type BundleErrors = Record<VariantsWithMainInfo['id'], EditBundleSalesChannelErrorType[]>;
